import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @description
 * Life science users have access to life science module
 * @returns {boolean} - can access or not
 */
export default function lifeScienceGuard(): boolean {
  const appUserSettingService = inject(AppUserSettingService);
  const isLifeScience = appUserSettingService.getIsLifeScience();

  if (isLifeScience) {
    return true;
  }

  const router = inject(Router);

  void router.navigate(['/']);

  return false;
}
